import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DokumentiPopisService } from './dokumenti-popis.service';
import { AppConfig } from '../../../config';
import { DokumentPopis } from './dokument';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import * as toastr from 'toastr';

declare var moment: any;
import * as alertify from 'alertify.js';

const MIME_TYPES = {
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetxml.sheet'
}

@Component({
  selector: 'app-dokumenti-popis',
  templateUrl: './dokumenti-popis.component.html',
  styleUrls: ['./dokumenti-popis.component.css'],
  providers: [DokumentiPopisService]
})
export class DokumentiPopisComponent implements OnInit {

  // @ViewChild('fileInput', {static: false}) fileInput;
  filee:any;

  sviDokumenti: DokumentPopis[] = [];
  dokumentOptions: DataTables.Settings = {};
  dokumentTrigger: Subject<DokumentPopis> = new Subject();

  dokumentForma: FormGroup;
  dokumentEditForma: FormGroup;

  dokumentId: string;
  accessToken: any = localStorage.getItem('tokenSql');
  URL: any = AppConfig.IPfile;

  constructor(
    private _dokumentiPopisService: DokumentiPopisService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.dokumentOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.dokumentForma = this._fb.group({
      naziv: [''],
      file: [''],
    });
    this.dokumentEditForma = this._fb.group({
      naziv: [''],
      datum: [''],
    });
  }

  pripremiPodatke(dokument){
    //console.log(dokument);
    this.dokumentId = dokument['id'];
    this.dokumentEditForma = this._fb.group({
      naziv: dokument['naziv'],
      datum: dokument['datum']
    });
  }

  uredi(dokument){
    //console.log(dokument);
    let podaciZaSlanje = {
      'iduploaddokument': this.dokumentId,
      'naziv': dokument['naziv'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._dokumentiPopisService.urediDokument(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(dokumentForma){
    //console.log(dokumentForma);
    if(dokumentForma['naziv'] && dokumentForma['file']){
      let formData:FormData = new FormData();
      formData.append('naziv', dokumentForma.naziv);
      formData.append('datoteka', this.filee[0], this.filee[0].name);
      formData.append('nazivtablice', 'uploaddokument');
      this._dokumentiPopisService.dodajDokument(formData).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodan video!");
          this.dohvati();
          this.dokumentForma = this._fb.group({
            naziv: [''],
            file: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviDokumenti = [];
    this._dokumentiPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviDokumenti.push({
            'id': res.data[i]['iduploaddokument'],
            'naziv': res.data[i]['ud_naziv'],
            'dokument': res.data[i]['ud_nazivdokumenta_orig'],
            'datum': moment(res.data[i]['ud_vrijemeuplouda']).format('DD.MM.YYYY.'),
            'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
            'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta']
          });
        }
        this.dokumentTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiDokument(dokument){
    //console.log(dokument);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati dokument?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._dokumentiPopisService.obrisiDokument({'iduploaddokument': dokument.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Dokument uspješno obrisan!");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja dokumenta.');
    });
  }

   
  /*
  preuzmiDokument(dokumentnaziv){
    console.log(dokumentnaziv);
  }
  */
  

  preuzmiDokument(idfile, fileName){
    console.log(idfile, fileName);
    const EXT = fileName.substr(fileName.lastIndexOf('.') + 1);
    this._dokumentiPopisService.spremiDokument({'iduploaddokument': idfile, 'fileName': fileName}).subscribe(res => {
      console.log('-----res-----', res);
      //save it on the client machine.
      //saveAs(new Blob([res], {type: MIME_TYPES[EXT]}), fileName);
    })
  }

  fileChange(event){
    //console.log(event)
    this.filee = event.target.files;
    //console.log(this.filee);
  }

  /*
  fileChange(event) {
    this.filee = event.target.files;
    if(this.filee){
      this.uploadDatoteke();
    }
  } 
  */

  /* 
  uploadDatoteke() {
    let formData:FormData = new FormData();
    formData.append('datoteka', this.filee[0], this.filee[0].name);
    formData.append('iddokument', '0');
    formData.append('nazivtablice', 'predmet');
    this._predmetDodajService.uploadPDF(formData).subscribe(res => {
      // console.log(res);
      if(res['success'] == true){
        this.idSlike = res['data'];
        toastr.success("Uspješan upload!");
      } else {
        toastr.error(res['message']);
      }
    });
  } 
  */


}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/dokumenti-popis/dokumenti-popis.component.ts